module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-stone-path-background-remnants.f8e7665c.png";